<template>
  <div v-if="course" class="px-3 md:px-0">
    <OlimpiadasLiveSessionBanner v-if="isOlimpiadasCourse" variant="app" class="mb-4" />
    <h1 class="text-lg font-bold">Descripción del curso</h1>

    <div class="text-neutral-700 mt-5 space-y-4">
     
      <vue-markdown :source="introductionMarkdown"></vue-markdown>

      <section
        v-if="isOlimpiadasCourse"
        class="rounded-xl border border-neutral-200 bg-neutral-50/80 p-4 md:p-5"
        aria-labelledby="olimpiadas-paises-heading"
      >
        <h2 id="olimpiadas-paises-heading" class="text-base font-bold text-neutral-900">
          Países participantes
        </h2>
        <p class="mt-2 text-sm text-neutral-600">
          Estudiantes inscritos en Olimpiadas Mobius 2026 provienen de los siguientes países (sin orden de preferencia).
        </p>
        <ul
          class="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-2.5 text-sm"
        >
          <li
            v-for="c in participatingCountries"
            :key="c.code"
            class="flex items-center gap-2 min-w-0"
          >
            <span class="text-lg leading-none shrink-0" aria-hidden="true">{{ flagEmoji(c.code) }}</span>
            <span class="font-medium text-neutral-800 truncate">{{ c.name }}</span>
          </li>
        </ul>
      </section>

      <div v-if="course.examDiag && course.examRequired">
        <MobMessage heading="Mensaje informativo" type="info" class="max-w-lg">
          Necesitamos conocer tu nivel actual de conocimientos y habilidades en
          este campo. Por lo tanto, te pedimos que tomes el examen diagnóstico
          antes de comenzar las lecciones. Este examen tiene como objetivo,
          entender dónde estás en tu camino de aprendizaje.
        </MobMessage>

        <button class="mob-btn mob-cta-gold-outline mt-3" @click="startExam">
          Tomar examen diagnóstico
        </button>
      </div>

      <button v-else-if="this.course.enrolled" class="mob-btn mob-cta-gold-outline" @click="startCourse">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
import { MobMessage } from "@/views/V2/components";
import { enrollToCourse } from "@/services/courses.service";
import VueMarkdown from "vue-markdown";
import mathJaxRender from "@/Utils/mathjax-render.js";
import OlimpiadasLiveSessionBanner from "@/views/V2/olimpiadas/OlimpiadasLiveSessionBanner.vue";
import { contests } from "@/views/V2/olimpiadas/contestData";
import { OLIMPIADAS_PARTICIPATING_COUNTRIES } from "@/views/V2/olimpiadas/olimpiadasParticipatingCountries";

const OLIMPIADAS_COURSE_ID = contests[0]?.courseId;

/** Quita el aviso temporal de enlaces a sesiones (texto puede venir en longDescription del curso). */
function stripOlimpiadasSessionsLinksSentence(text) {
  if (!text || typeof text !== "string") return "";
  let out = text;
  const patterns = [
    /Próximamente\s+publicaremos\s+[^.\n]*?100%\s*virtuales\.?/gi,
    /Proximamente\s+publicaremos\s+[^.\n]*?100%\s*virtuales\.?/gi,
  ];
  for (const p of patterns) {
    out = out.replace(p, "");
  }
  return out.replace(/\n{3,}/g, "\n\n").trim();
}

export default {
  name: "CourseIntroduction",
  components: {
    MobMessage,
    VueMarkdown,
    OlimpiadasLiveSessionBanner,
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
    isOlimpiadasCourse() {
      const fromRoute = Number(this.$route.params.id);
      const fromStore = this.course?.id;
      const id = Number.isFinite(fromStore) ? Number(fromStore) : fromRoute;
      return OLIMPIADAS_COURSE_ID != null && id === OLIMPIADAS_COURSE_ID;
    },
    introductionMarkdown() {
      const raw = this.course?.longDescription || "";
      if (this.isOlimpiadasCourse) {
        return stripOlimpiadasSessionsLinksSentence(raw);
      }
      return raw;
    },
    participatingCountries() {
      return OLIMPIADAS_PARTICIPATING_COUNTRIES;
    },
  },
  watch: {
    introductionMarkdown() {
      this.$nextTick(() => {
        if ("MathJax" in window && window.MathJax && window.MathJax.Hub) {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        }
      });
    },
  },
  methods: {
    flagEmoji(code) {
      if (!code || typeof code !== "string" || code.length !== 2) return "";
      const cc = code.toUpperCase();
      return String.fromCodePoint(
        ...[...cc].map((c) => 127397 + c.charCodeAt(0))
      );
    },
    async startCourse() {
      this.$router.push("lessons");      
    },
    async startExam() {
      if (!this.course.enrolled) {
        await enrollToCourse(this.course.id);
      }
      this.$router.push("diagnosticTest");
    },
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

    window.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"],
        ],
      },
    });
  },
  async mounted() {
    mathJaxRender();
  },
};
</script>
